/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  Breadcrumb, Col, Popconfirm, Row,
} from 'antd';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { routes } from '../../../utils/routes';
import getApplicationStatusTag from '../../Home/components/HomePageDesktop/utils/getApplicationStatusTag';
import getUserRole from '../../../utils/localeStorage/getUserRole';


function Navigation({
  view, onChangeView, application, tabs, onAddStep, hasAddStep,
}) {
  const getDisplayIdPostfix = () => {
    if (application?.displayID?.includes('НИР') || application?.displayID?.includes('С')) {
      return application.displayID;
    }
    return `${application?.displayID}/25`;
  };

  return (
    <div>
      <Breadcrumb>
        <Breadcrumb.Item>
          <a href={routes.homePage}>Список заявок</a>
        </Breadcrumb.Item>
        <Breadcrumb.Item>
          {`Заявка №${getDisplayIdPostfix()}`}
          {getApplicationStatusTag(application.status)}
        </Breadcrumb.Item>
      </Breadcrumb>
      {/* <span style={{ fontSize: '22px', fontWeight: 'bold' }}>{application.theme}</span> */}

      <Row
        justify="space-between"
        align="middle"
        style={{
          width: '100%',
          margin: '20px 0px',
          backgroundColor: '#fff',
          borderRadius: '25px',
          padding: '20px',
        }}
      >
        <Col>
          <Row gutter={40}>
            {tabs.map((tab, index) => (
              <Col>
                <Row
                  style={{
                    alignItems: 'center',
                    cursor: view === tab.value ? 'initial' : 'pointer',
                  }}
                  onClick={() => onChangeView(tab.value)}
                >
                  <Col>
                    <div
                      style={{
                        padding: '5px',
                        borderRadius: '100%',
                        width: '40px',
                        height: '40px',
                        backgroundColor:
                          view === tab.value ? '#1890FF' : '#e9e9e9',
                        color: view === tab.value ? '#fff' : '#959595',
                        fontSize: '20px',
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      {index + 1}
                    </div>
                  </Col>
                  <Col>
                    <div
                      style={{
                        color: view === tab.value ? '#1890FF' : '#959595',
                        fontSize: '18px',
                        marginLeft: '10px',
                      }}
                      dangerouslySetInnerHTML={{ __html: tab.label }}
                    />
                  </Col>
                </Row>
              </Col>
            ))}
            {getUserRole() === 'bigAdmin' && hasAddStep && (
            <Col>
              <Popconfirm
                title="Вы действительно добавить этап?"
                onConfirm={onAddStep}
                okText="Да"
                cancelText="Нет"
              >
                <Row style={{ alignItems: 'center', cursor: 'pointer' }}>
                  <Col>
                    <div style={{
                      padding: '5px', borderRadius: '100%', width: '40px', height: '40px', backgroundColor: '#e9e9e9', color: '#959595', fontSize: '20px', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center',
                    }}
                    >
                      +
                    </div>
                  </Col>
                </Row>
              </Popconfirm>
            </Col>
            )}
          </Row>
        </Col>
      </Row>
    </div>
  );
}

Navigation.propTypes = {
  view: PropTypes.string.isRequired,
  onChangeView: PropTypes.func.isRequired,
  application: PropTypes.shape().isRequired,
  tabs: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  onAddStep: PropTypes.func.isRequired,
  hasAddStep: PropTypes.bool.isRequired,
};

export default withRouter(Navigation);
